export const STREAM_TYPES = Object.freeze({
  COMMENTS: 'comments',
  EVENTS: 'events',
});
